import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'

import { contractUpdateApi } from './api'

const useContractsUpdate = () => {
  const { data, isLoading, refetch } = useQuery(
    [QUERY_KEYS.CONTRACTS_UPDATE],
    contractUpdateApi.getContractsUpdate,
  )

  return {
    contractUpdate: data,
    isContractLoading: isLoading,
    updateContracts: refetch,
  }
}

export { useContractsUpdate }
